import { Sparkle, Quotes } from "@phosphor-icons/react";

const ART =
  "https://static.prod-images.emergentagent.com/jobs/8c4d6d9d-84a2-4f25-b806-0954dc297e1c/images/d560b6cb200cf101fcac90aa400cec4857becd7aa861b86cbafb7c6990ab13a2.png";

// Render simple inline markdown: *italic* and **bold** within a paragraph string
function renderInline(text) {
  const parts = [];
  const regex = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const token = match[0];
    if (token.startsWith("**")) {
      parts.push(<strong key={key++}>{token.slice(2, -2)}</strong>);
    } else {
      parts.push(<em key={key++}>{token.slice(1, -1)}</em>);
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}

export const Biography = ({ biography }) => {
  if (!biography) return null;
  const paragraphs = biography.paragraphs || [];
  return (
    <div
      className="editorial-card grid grid-cols-1 lg:grid-cols-12 gap-0 mt-6 avoid-break"
      data-testid="biography-panel"
    >
      <div className="lg:col-span-4 relative bg-paper-alt overflow-hidden border-b lg:border-b-0 lg:border-r border-paper-edge min-h-[220px] grain">
        <img
          src={ART}
          alt=""
          className="absolute inset-0 w-full h-full object-cover mix-blend-multiply opacity-90"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(80% 100% at 0% 0%, rgba(232,163,61,0.55) 0%, rgba(232,163,61,0) 65%), radial-gradient(80% 100% at 100% 100%, rgba(46,58,135,0.55) 0%, rgba(46,58,135,0) 65%)",
          }}
        />
        <div className="relative p-6 lg:p-8 h-full flex flex-col justify-between text-ink">
          <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-overline w-fit bg-white/85 px-2.5 py-1 border border-ink/10">
            <Sparkle size={12} weight="duotone" className="text-terracotta" />
            <span>Editorial profile</span>
          </div>
          <Quotes
            size={56}
            weight="duotone"
            className="text-terracotta opacity-80 mt-6"
          />
          <div className="font-display italic text-xl lg:text-2xl mt-4 leading-snug">
            &ldquo;Reconciling operational innovation with normative ethics.&rdquo;
          </div>
        </div>
      </div>
      <div className="lg:col-span-8 p-6 lg:p-10">
        {biography.title && (
          <h3
            className="font-display text-3xl lg:text-4xl tracking-tight leading-tight mb-5"
            data-testid="biography-title"
          >
            {biography.title.replace(/^#+\s*/, "")}
          </h3>
        )}
        <div
          className="font-display text-lg lg:text-xl leading-[1.6] text-ink space-y-5"
          data-testid="biography-body"
        >
          {paragraphs.map((p, i) => (
            <p key={p.slice(0, 40)} className={i === 0 ? "drop-cap" : ""}>
              {renderInline(p)}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Biography;
